import { CREAT_OR_UPDATE_PARENT } from "../../routes";
import customAxios from "../../customAxios";

type Props = {
  phoneNumber: string;
  firstName  : string;
  province   : string;
  lastName   : string;
  gender     : string;
  city       : string;
}

async function createOrUpdateParent(props: Props): Promise<any> {
  try {
    return (await customAxios.post(CREAT_OR_UPDATE_PARENT, props)).data;
  } catch (error: any) {
    console.error({ CREAT_OR_UPDATE_PARENT: error });
  }
}

export default createOrUpdateParent;
